// eslint-disable-next-line import/prefer-default-export
export const GET_SUPPLY_COMPOSITION_DATA = 'GET_SUPPLY_COMPOSITION_DATA';
